'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = require('./components/Table.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Table).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table/index.js
// module id = 1356
// module chunks = 1